import useGetCount from '../../explore/useGetCount';
import allSites from '../../sites/useQuery';
import unlinkedProjects from '../../sites-filtered/unlinked-projects/useQuery';
import unlinkedEvents from '../../sites-filtered/unlinked-events/useQuery';
import missingRoles from '../../sites-filtered/missing-roles/useQuery';

export default function getNavigationLinks() {
  return [
    { id: 'all', name: 'All', href: `/sites`, count: useGetCount(allSites) },
    { id: 'unlinked-projects', name: 'Unlinked Projects', href: `/sites/unlinked-projects`, count: useGetCount(unlinkedProjects) },
    { id: 'unlinked-events', name: 'Unlinked Events', href: `/sites/unlinked-events`, count: useGetCount(unlinkedEvents) },
    { id: 'org-roles-cleanup', name: 'Orgs/Roles to cleanup', href: `/sites/missing-roles`, count: useGetCount(missingRoles) },
    { id: 'map', name: 'Map', href: `/sites/map`, count: useGetCount(allSites) },
  ];
}
